import { useParams } from 'react-router';
import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { TicketDetail } from '@/components/features/tickets';

export function TicketPage() {
  const { ticketId = '' } = useParams();

  return (
    <>
      <Meta title="Support ticket" />

      <Container>
        <TicketDetail ticketId={ticketId} />
      </Container>
    </>
  );
}
